import { SectionHeading } from './SectionHeading'

export function Access() {
  return (
    <section
      id="access"
      className="section-wrapper relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white via-slate-50 to-slate-100" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="Access" title="アクセス" />

        <div className="max-w-4xl mx-auto space-y-6">
          <div className="animate-on-scroll animate-on-scroll-delay-1 grid sm:grid-cols-2 gap-4">
            <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm">
              <h3 className="text-brand-blue font-semibold mb-3 text-sm tracking-wider uppercase">
                Address
              </h3>
              <p className="text-brand-navy font-medium mb-1">
                株式会社ジェイフロンティア
              </p>
              <p className="text-brand-navy/60 text-sm leading-relaxed">
                〒169-0075
                <br />
                東京都新宿区高田馬場1丁目31-7
                <br />
                ソアブール高田馬場2F
              </p>
            </div>

            <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm">
              <h3 className="text-brand-blue font-semibold mb-3 text-sm tracking-wider uppercase">
                Station
              </h3>
              <p className="text-brand-navy/60 text-sm leading-relaxed">
                JR山手線・西武新宿線・東京メトロ東西線
                <br />
                <span className="text-brand-navy font-medium">
                  「高田馬場駅」
                </span>
                より徒歩3分
              </p>
            </div>
          </div>

          <div className="animate-on-scroll animate-on-scroll-delay-2 rounded-2xl overflow-hidden shadow-xl h-72 md:h-80">
            <iframe
              title="会社地図"
              src="https://maps.google.com/maps?q=東京都新宿区高田馬場1丁目31-7+ソアブール高田馬場&hl=ja&z=15&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
